import React, { createContext, useContext } from "react";

export const ResultReviewContext = createContext({
  evidenceBySegment: {}, selected: null, select: () => {}, page: 1,
});

export const useResultReview = () => useContext(ResultReviewContext);

export const CONF_STYLE = {
  HIGH: "bg-emerald-100 text-emerald-900 border-emerald-300",
  MEDIUM: "bg-sky-100 text-sky-900 border-sky-300",
  LOW: "bg-amber-100 text-amber-900 border-amber-300",
};

export const Conf = ({ value, testId }) => (
  <span className={`px-1 border text-[9px] font-bold ${CONF_STYLE[value] || "bg-secondary text-muted-foreground border-border"}`} data-testid={testId}>
    {value || "N/D"}
  </span>
);

export const Unknown = ({ label = "UNKNOWN", testId }) => (
  <span className="px-1 border border-amber-400 bg-amber-50 text-amber-900 text-[9px] font-bold" data-testid={testId}>{label}</span>
);

/** Chip evidenza: risolve (segmento, id) → testo/pagina reali del segmento; clic = vai alla pagina PDF. */
export const EvidenceChip = ({ segId, evId, testId }) => {
  const { evidenceBySegment, selected, select } = useResultReview();
  const ev = (evidenceBySegment[segId] || []).find((e) => e.evidence_id === evId);
  const isSel = selected && selected.segId === segId && selected.evId === evId;
  return (
    <button type="button" onClick={() => select(segId, evId)}
      title={ev ? `p.${ev.page} — ${ev.text}` : "evidenza non risolta nel segmento"}
      className={`inline-flex items-center gap-0.5 px-1 border text-[9px] font-mono leading-4 ${isSel ? "border-red-500 bg-red-50 text-red-900" : ev ? "border-cyan-500/60 bg-cyan-50 text-cyan-900 hover:bg-cyan-100" : "border-red-300 bg-red-50 text-red-800 line-through"}`}
      data-testid={testId || `evidence-chip-${segId}-${evId}`}>
      {evId}{ev ? <span className="font-sans text-muted-foreground">p.{ev.page}</span> : "?"}
    </button>
  );
};

export const EvidenceList = ({ segId, ids }) => (
  <span className="inline-flex flex-wrap gap-0.5">{(ids || []).map((id) => <EvidenceChip key={id} segId={segId} evId={id} />)}</span>
);

/** Misura canonica {value, unit, origin, confidence, source_refs} → riga leggibile; null = UNKNOWN evidenziato. */
export const Measure = ({ m, segId, unitFallback = "", testId }) => {
  if (!m || m.value == null) return <Unknown testId={testId} />;
  return (
    <span className="inline-flex flex-wrap items-center gap-1" data-testid={testId}>
      <b>{m.value}{m.unit ? ` ${m.unit}` : unitFallback}</b>
      {m.origin && m.origin !== "UNKNOWN" && <span className="text-[9px] text-muted-foreground">{m.origin}</span>}
      <Conf value={m.confidence} />
      <EvidenceList segId={segId} ids={m.source_refs} />
    </span>
  );
};
